import http from './api';

const createEmailSignature = emailSignature => http.post('api/email-signature', emailSignature);
const updateEmailSignature = emailSignature =>
  http.patch(`api/email-signature/${emailSignature.organizationId}`, emailSignature);
const getOrganizationSignatures = organizationId => http.get(`api/email-signature/${organizationId}`);
const overwriteEmailSignature = (orgId, emailsToOverwrite) =>
  http.patch(`api/email-signature/${orgId}/overwrite`, emailsToOverwrite);
const overwriteDefaultSignature = orgId => http.patch(`api/email-signature/${orgId}/default`);

export default {
  createEmailSignature,
  updateEmailSignature,
  getOrganizationSignatures,
  overwriteEmailSignature,
  overwriteDefaultSignature
};
